export default __webpack_public_path__ + "media/music/ce9dd1947bb562652d69cdee8ecab1bf.mp3";